module.exports = __webpack_public_path__ + "media/assets/images/flags/my-f949633b5bac01173dbb59b4b8aa148a.svg";